/**
Classe base astratta con i campi comuni ai modelli eloquent
*/
export abstract class AbstractModel implements Model {
	id?: number
	updated_at?: string
	created_at?: string
	/**
	usato se questo modello è basato su soft-delete
	*/
	deleted_at?: string

	pivot?: any
}

export interface Model {
	id?: number,
	updated_at?: string,
	created_at?: string,
	deleted_at?: string,//usato se questo modello è basato su soft-delete


	pivot?: any//Usato se questo modello è caricato come many-to-many con pivot
}

export interface Account {
	id: number,
	identifier: string,
	secret?: string,
	type: AccountType,

	user_id: number,
	user?: User
}

export enum AccountType {
	PIN = "pin",
	EMAIL_PASSWORD = "email_password"
}

/**
Indirizzo, usabile anche come contatto
*/
export class Address extends AbstractModel {
	location: Location
	location_id?: number

	user?: User
	user_id?: number

	cell: string
	email: string
	fax: string
	fiscal_code: string
	floor: string
	formatted: string
	internal: string
	owner: any
	name: string
	owner_id: number
	owner_type: string
	pec: string
	postal_code: string
	phone: string
	priority: number
	route: string
	stair: string
	street_number: string
	type: AddressType
	vat_number: string
}

export enum AddressOwnerType {
	CONDOMINIUM = "Condominium",
	USER = "User"
}

export enum AddressType {
	CONTACT = "contact",
	LOCATION = "location"
}


export enum CadastalType {
	BUILDINGS = 'buildings',
	LANDS = 'lands',
	NONE = ''//segnaposto per valorizzare select e radio
}

/**
Stato della chiamata VOIP.

NOTE: Per mantenere robustezza, linearità e leggibilità questi stati vanno impostati ciascuno una volta soltanto, nei punti in cui cambia lo stato, e per loro natura non possono regredire
*/
export enum CallStatus {
	/**
	pre-inizializzazione
	*/
	NEW = 'NEW',
	/**
	Richiesta di presa in gestione inviata
	*/
	REQUESTING = 'REQUESTING',
	/**
	preso in gestione e aspetto risposta utente
	*/
	RINGING = 'RINGING',
	/**
	inviando stream
	*/
	SENDING = 'SENDING',
	/**
	invio e ricezione stream
	*/
	CONNECTED = 'CONNECTED',
	/**
	Chiamata chiusa
	*/
	DISCONNECTED = 'DISCONNECTED'
}


export interface Condominium extends Model {
	address?: Address,
	administrators?: User[],
	contacts?: Address[],
	devices?: Device[],
	heatingreaders?: User[],
	housing_units?: HousingUnit[],
	messages?: Message[],
	users?: User[],
	user_roles?: CondominiumUser[],
	workers?: User[],
	intercomUser?: User,

	name: string,
	settlement: string,
	timetable: string,
	fiscal_code: string,
	area_1: string,
	area_2: string,
	area_3: string,
	area_4: string,
	area_5: string,
	area_6: string,

	/**
	Usato come suffisso della classe del tema, ee. default -> theme_default
	*/
	theme?: string
}

export interface CondominiumUser extends Model {
	condominium_id: number,
	user_id: number,

	is_administrator: boolean,
	is_heatingreader: boolean,
	is_worker: boolean
}

/**
Ruoli utente disponibili per il condominio
*/
export enum CondominiumUserRole {
	is_administrator = 'is_administrator',
	is_heatingreader = 'is_heatingreader',
	is_worker = 'is_worker'
}

export enum DeviceCache {
	/**
	Usa cache / Storage se disponibile, altrimenti remota
	*/
	ALL = 'ALL',
	/**
	Usa solo la versione cache
	*/
	CACHED = 'CACHED',
	/**
	Usa la versione remota, se ha errore di connessione usa cache
	*/
	FALLBACK = 'FALLBACK',
	/**
	Usa solo la versione remota
	*/
	REMOTE = 'REMOTE',
}

/*
Tipologie dispositivi configurabili
*/
export enum DeviceType {
	BROWSER = "browser",
	DASHBOARD = "dashboard",
	INTERCOM = "intercom",
	SMARTPHONE = "smartphone",
}

/*
Dispositivi fisici
*/
export interface Device extends Model {
	name: string,
	note: string,
	type: DeviceType,
	identifier: string,//UUID
	ice_mode: IceMode,
	is_development_mode: boolean,
	is_security_cam_enabled: boolean,
	always_on_front_mode: string,
	condominium_id?: number,
	condominium?: Condominium,
	theme?: string
}

/*
Nomi degli eventi custom di questo dominio applicativo;
Gli eventi nell'app vengono propagati con questo nomi, e possono essere ricevuti registrando gli handler su questi nomi
*/
export enum DomainEvents {
	ANDROID_MESSAGE_RECEIVED= 'android.message.received',

	DEVICE_ACTUAL_IDENTIFIED = "device.actual.identified",
	/**
	Aggiornamento configurazione dispositivo correttamente

	Parametri:
	- device:Device
	- time
	- previous:Device
	*/
	DEVICE_ACTUAL_UPDATED = "device.actual.updated",
	//DEVICE_ACTUAL_TYPE_UPDATED = "device.actual.type.updated",

	/*
	Ricevuto un nuovo intent (Android)
	Parametri: L'intent ricevuto
	*/
	INTENT_RECEIVED = "intent.received",


	/*
	Ricevuta la notifica di messaggi non letti.
	Parametro: messageUnreadNotification: MessageUnreadNotification
	**/
	MESSAGE_VISIBLE_NOTIFICATION = 'message.visible',

	/**
	Ricevuta richiesta apertura portone
	*/
	OPEN_DOORWAY_REQUEST = 'doorway-open-request',
	/**
	Ricevuta risposta a richiesta apertura portone
	*/
	OPEN_DOORWAY_RESPONSE = 'doorway-open-response',

	/**
	Ricevuta Answer su connessione P2P RTC

	Parametri: Other ID, remoteSessionDescription
	*/
	RTCAnswerReceived = 'rtc.answer.received',
	/**
	Parametro: ID altro peer
	*/
	RTCCallHandled = 'rtc.call.handled',
	/**
	Ricevuta notifica di chiusura connessione
	*/
	RTCHangupReceived = 'rtc.hangup.received',
	/**
	Parametro: ID altro peer
	*/
	RTCNegotiationNeeded = 'rtc.negotiation.needed',
	/**
	Connessione RTC con il peer aperta (Uno degli ICE in uso)
	Parametro: ID altro peer
	*/
	RTCPeerConnected = 'rtc.peer.connected',
	/**
	Connessione con il peer chiusa, può essere riaperta

	Parametro: ID altro peer
	*/
	RTCPeerDisconnected = 'rtc.peer.disconnected',
	/**
	Connessione con il peer chiusa definitivamente

	Parametro: ID altro peer
	*/
	RTCPeerClosed = 'rtc.peer.closed',
	/**
	Ricevuta Offer su connessione P2P RTC

	Parametri: Other ID, remoteSessionDescription
	*/
	RTCOfferReceived = 'rtc.offer.received',
	/**
	Parametri: ID altro peer, stream
	*/
	RTCStreamIncoming = 'rtc.stream.incoming',

	/**
	Chiamata in arrivo via server signaling

	parametri:

	- messaggio call_init ricevuto
	*/
	ServerSignalingCallIncoming = "server.signaling.call.incoming",
	/**
	Errore nella connessione al server signaling
	*/
	ServerSignalingConnectionError = "server.signaling.connection.error",
	/**
	Connessione stabilita con il server di signaling
	*/
	ServerSignalingOnline = "server.signaling.online",
	/**
	Connessione al server signaling chiusa e finalizzata
	*/
	//ServerSignalingConnectionFinalized = "server.signaling.connection.finalized",
	/**
	disconnesso dal server signaling
	*/
	ServerSignalingOffline = "server.signaling.offline",
	/**
	Registrato con peer id
	*/
	ServerSignalingLogin = "server.signaling.login",
	/**
	id peer de-registrato dal server (nessun messaggio leggibile)
	*/
	ServerSignalingLogout = "server.signaling.logout",
	/**
	Ricevuto PING (dovrebbe rispondere con PONG)
	*/
	SERVER_SIGNALING_PING = "server.signaling.ping",
	/**
	Ricevuto PONG (risposta a PING)
	*/
	SERVER_SIGNALING_PONG = "server.signaling.pong",
	/**
	Connessione da un altro peer in arrivo, non ancora accettata
	*/
	//ServerSignalingPeerConnecting = "server.signaling.peer.connecting",
	/**
	Errore nella connessione di signaling P2P
	*/
	//ServerSignalingPeerConnectionError = "server.signaling.peer.connection.error",
	/**
	Connesso con un altro peer
	*/
	/*
	ServerSignalingPeerConnected = "server.signaling.peer.connected",
	*/
	/**
	Connessione di signaling a un altro peer terminata
	*/
	//ServerSignalingPeerDisconnected = "server.signaling.peer.disconnected",
	/**
	Messaggio in arrivo da un altro peer attraverso il server di signaling
	*/
	ServerSignalingPeerMessageReceived = "server.signaling.peer.message.received",

	/**
	Autenticazione Utente
	Parametri:
	- utente loggato
	- time
	*/
	USER_LOGIN = "user.login",
	USER_LOGOUT = "user.logout",
	/**
	Ricevuta richiesta di eseguire logout
	*/
	USER_LOGOUT_REQUESTED = "user.logout.requested",

	/**
	Chiusura chiamata VOIP in corso
	*/
	VOIPCALL_CLOSE = 'voipcall.close'
}

export enum IceMode {
	AUTO = 'auto',
	PUBLIC = 'public',
	PUBLIC_STUN = 'public_stun',
	XIRSYS = 'xirsys'
}

export interface Location extends Model {
	name: string
}

export enum LogLevel {
	DEBUG = 'debug',
	ERROR = 'error',
	INFO = 'info',
	LOG = 'log',//default
	WARNING = 'warning',
}


export interface HousingUnit extends Model {
	condominium_id: number

	condominium?: Condominium,
	intercom_user?: User,
	intercom_user_id?: number,
	intercom_phone?: string,
	owners?: User[],
	residents?: User[],
	users?: User[],
	messages?: Message[],
	note?: string,
	is_message_audio_enabled?: boolean,
	is_message_video_enabled?: boolean,
	is_auto_open_enabled?: boolean,

	user_roles?: HousingUnitUser[],

	internal: string,
	label: string,
	floor: string,
	stair: string,

	cadaster_city_code: string,
	cadastal_type: CadastalType,
	cadastal_administrative_section: string,
	cadastal_census_section: string,
	cadastal_urban_section: string,
	cadastal_paper: string,
	cadastal_particle: string,
	cadastal_subaltern: string,
	cadastal_zone: string,
	cadastal_microzone: string,
	cadastal_category: string,
	cadastal_class: string,
	cadastal_rooms: number,
	cadastal_revenue: number
}

export interface HousingUnitUser extends Model {
	housing_unit_id: number,
	user_id: number,

	is_owner: boolean,
	is_resident: boolean
}

/**
Ruoli utente disponibili per un utente su una unità abitativa
*/
export enum HousingUnitUserRole {
	is_owner = 'is_owner',
	is_resident = 'is_resident',
}

export interface Message extends Model {
	/**
	Utente o citofono (a unità abitativa)
	*/
	sender?: User | Device,
	/**
	Utente, condominio (bacheca) o unità abitativa (da citofono)
	*/
	receiver?: User | Condominium | HousingUnit,

	condominium_id?: number,
	housing_unit_id?: number,

	is_hidden_to_receiver?: boolean,
	is_hidden_to_sender?: boolean,

	receiver_id: number,
	receiver_type: string,
	sender_id: number,
	sender_type: string,
	thread_id?: number,

	created_at: any,
	updated_at: any,
	pin_until: any,
	visibility: MessageVisibility,
	status: string,
	type: MessageType,
	priority: MessagePriority,
	subject: string,
	body: string,
	condominium?: Condominium,
	housing_unit?: HousingUnit
}

export enum MessagePriority {
	HIGH = "high",
	NORMAL = "normal",
	LOW = "low"
}

export enum MessageReceiverType {
	CONDOMINIUM = "Condominium",
	HOUSING_UNIT = "HousingUnit",
	USER = "User"
}

export enum MessageType {
	AUDIO = 'audio',
	TEXT = 'text',
	VIDEO = 'video',
}


export interface MessageVisibleNotification {
	last?: Message,
	count: number
}

export enum MessageVisibility {
	PUBLIC = "public",
	PRIVATE = "private"
}


/**
Id per recuperare le notifiche del plugin native notification
*/
export enum NotificationId {
	MESSAGE_VISIBLE_NOTIFICATION = 10001
}

export interface SignalingMessage {
	/**
	Eventuali dati accessori
	*/
	data?: any,
	/**
	Timestamp invio effettuato (impostato dal server di signaling all'ultimo step di invio)
	*/
	sentAt?: Date,
	/**
	Timestamp ricezione (impostato dal server di signaling al primo step di ricezione)
	*/
	receivedAt?: Date,
	/**
	Id peer receiver
	*/
	receiverId?: string,
	/**
	Id peer sender
	*/
	senderId?: string,
	/**
	Candidato ICE
	*/
	iceCandidate?: RTCIceCandidate,
	/**
	Id device associato
	*/
	deviceId?: number,
	/**
	Identificativo device associato
	*/
	deviceIdentifier?: string,
	/**
	Id housing unit associata
	*/
	housingUnitId?: number,
	/**
	Id utente associato
	*/
	userId?: number,
	/**
	Nel caso di messaggi di risposta, il messaggio di richiesta a cui rispondono
	*/
	request?: SignalingMessage,
	/**
	Descrittore delle capacità dei media e del canale
	*/
	sessionDescription?: RTCSessionDescription,
	type: SignalingMessageType
}


export enum SignalingMessageType {
	ANSWER = 'answer',
	/**
	Invio candidato ice
	*/
	ICE_CANDITATE = 'ice-candidate',
	/**
	Tutti i candidati ICE sono stati inviati
	*/
	ICE_CANDITATES_SENT = 'ice-candidate-sent',
	OFFER = 'offer',
	//DATA = 'data',//dati liberi
	/**
	Sta arrivando una chiamata dal mittente
	*/
	CALL_INIT = 'call-init',
	/**
	Ricevuta richiesta di chiamata
	*/
	CALL_HANDLED = 'call-handled',
	/**
	Chiusura della chiamata
	*/
	CALL_HANGUP = 'call-hangup',
	/**
	Messaggio di login del peer-id al server di signaling.
	*/
	LISTEN = "listen",
	/**
	Messaggio di logout del peer-id al server di signaling, può opzionalmente rimanere connesso ma non riceve più i messaggi per questo destinatario
	*/
	DELISTEN = "delisten",
	/**
	Richiede ai riceventi di eseguire il logout, a meno che non corrisponda al dispositivo opzionalmente specificato.
	*/
	LOGOUT_REQUEST = "logout-request",
	/**
	Richiesta apertura portone
	*/
	OPEN_DOORWAY = 'doorway-open',
	/**
	Esito richiesta apertura portone
	*/
	OPENED_DOORWAY = 'doorway-opened',
	/**
	Ping per verifica presenza online
	*/
	PING = 'ping',
	/**
	Pong per conferma presenza online
	*/
	PONG = 'pong',
	/**
	Messaggio di signaling generico da passare
	*/
	SIGNALING = 'signaling',
}

export enum SignalingServerType {
	SOCKETIO = "socket.io",
	PEERJS = "peerJS",
	FIREBASE = "firebase"
}

export enum SignalingServerConnectionStatus {
	/**
	Connesso al server, in ascolto
	*/
	CONNECTED = 'connected',
	/**
	Server online ma non in ascolto, peerId non assegnato
	*/
	DISCONNECTED = 'disconnected',
	/**
	Server offline
	*/
	OFFLINE = 'offline'
}
/**
Chiavi per la persistenza nello storage
*/
export enum StorageKeys {
	AUTH_ACCOUNT_IDENTIFIER = 'auth.account.identifier',
	AUTH_ACCOUNT_SECRET = 'auth.account.secret',
	AUTH_ACCOUNT_TYPE = 'auth.account.type',

	/**
	Backup disopositivo corrente, serializzato
	*/
	DEVICE_ACTUAL = 'device.actual',
	/**
	Identificatore del dispositivo corrente
	*/
	DEVICE_IDENTIFIER = 'device.identifier'
}

/**
Stringhe delle UI
*/
export enum UIStrings {
	CREATE = 'Aggiungi',
	DELETE = 'Rimuovi dal sistema',
	DIALOG_CANCEL = 'Annulla',//Annulla, in particolare per i dialog
	DIALOG_OK = 'OK',
	DOORWAY_OPEN = 'Apri portone',
	EDIT = 'Modifica',
	LISTS = 'Elenca',
	MENU_CLOSE = 'Chiudi menù',
	ROLE_REMOVE = 'Rimuovi il ruolo',
	SHOW = 'Visualizza',
}

export interface User extends Model {
	api_key?: string,

	name: string,
	surname: string,
	email: string,
	pec: string,
	fiscal_code: string,
	vat_number: string,
	type: UserType,//'company','person'
	api_token: string,
	phone: string,
	cell: string,
	fax: string,
	birthday: string,
	is_admin: boolean,
	is_operator: boolean,
	is_administrator: boolean,
	is_resident: boolean,
	is_owner: boolean,
	is_worker: boolean,
	is_heatingreader: boolean,
	gender: string,//'M','F'

	accounts: Account[],
	address?: Address,//Indirizzo di contatto/domicilio
	contacts?: Address[],//Rubrica personale
	condominiums: Condominium[],
	housing_units: HousingUnit[],
	messages: Message[],
	sentMessages: Message[],
}

export enum UserType {
	COMPANY = 'company',
	PERSON = 'person'
}

/**
Ruoli utente disponibili per un utente
*/
export enum UserRole {
	is_admin = 'is_admin',
	is_administrator = 'is_administrator',
	is_heatingreader = 'is_heatingreader',
	is_operator = 'is_operator',
	is_worker = 'is_worker'
}



// WEBPACK FOOTER //
// ./src/models/models.ts